// FIX 13/06: hook que retorna o timezone do tenant logado.
// Fetch GET /holidays/defaults uma vez por sessao e cacheia em memoria global.
//
// Uso:
//   const tz = useTenantTimezone();
//   formatTenantTime(msg.createdAt, tz, "dd/MM HH:mm");

import { useEffect, useState } from "react";
import api from "../../services/api";

let cachedTimezone = null;
let inflightPromise = null;

export function useTenantTimezone() {
  const [tz, setTz] = useState(cachedTimezone || "America/Sao_Paulo");

  useEffect(() => {
    if (cachedTimezone) {
      setTz(cachedTimezone);
      return;
    }
    if (!inflightPromise) {
      inflightPromise = api
        .get("/holidays/defaults")
        .then((res) => {
          const v = res?.data?.timezone || "America/Sao_Paulo";
          cachedTimezone = v;
          return v;
        })
        .catch(() => {
          cachedTimezone = "America/Sao_Paulo";
          return cachedTimezone;
        })
        .finally(() => {
          inflightPromise = null;
        });
    }
    let mounted = true;
    inflightPromise.then((v) => mounted && setTz(v));
    return () => { mounted = false; };
  }, []);

  return tz;
}

// helper p/ invalidar cache quando user troca de company / faz logout
export function clearTenantTimezoneCache() {
  cachedTimezone = null;
  inflightPromise = null;
}

export default useTenantTimezone;
